<div class="fluid-container">
  <div class="text-center page-not-found-text">
    <h1>{{ 'page-not-found' | translate }}</h1>
  </div>
</div>
